import OrganizationPhotos from "./OrganizationPhotos";
export default OrganizationPhotos;
